module.exports = __webpack_public_path__ + "media/mypage/images/icons/credit-cards/jcb-cd0c7b026f94f930e79473c9423ae895.png";